import { handleKoResponse } from "./common/fetchHelper";

export async function getCountries(resourceToken: string, language: string) {
    const headers = new Headers();
    headers.set('Content-Type', 'application/json');
    headers.set('Authorization', `bearer ${resourceToken}`);

    const requestUrl = `${process.env.REACT_APP_API_URL}/countries`;
    const requestOptions: RequestInit = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(requestUrl, requestOptions);
    await handleKoResponse(response);

    const countryDtos = (await response.json()) as ICountryDto[]
    const countries = countryDtos.map<ICountry>(c => mapFromDto(c));

    return translateCountries(language, countries);
}

function mapFromDto(dto: ICountryDto): ICountry {
    return {
        code: dto.code,
        phonePrefix: dto.phone_prefix,
        name: dto.name
    };
}

interface ICountryDto {
    code: string;
    phone_prefix: string;
    name: string;
}

export interface ICountry {
    code: string;
    phonePrefix: string;
    name: string;
}

export interface ITranslatedCountry {
  code: string;
  name: string;
}

interface CountriesDictionary {
  [key: string]: ITranslatedCountry[];
}

const countriesInEnglish: ITranslatedCountry[] = [
  {
    code: 'AF',
    name: 'Afghanistan',
  },
  {
    code: 'AL',
    name: 'Albania',
  },
  {
    code: 'DZ',
    name: 'Algeria',
  },
  {
    code: 'AX',
    name: 'Alland Islands',
  },
  {
    code: 'AS',
    name: 'American Samoa',
  },
  {
    code: 'AD',
    name: 'Andorra',
  },
  {
    code: 'AO',
    name: 'Angola',
  },
  {
    code: 'AI',
    name: 'Anguilla',
  },
  {
    code: 'AQ',
    name: 'Antarctica',
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    code: 'AR',
    name: 'Argentina',
  },
  {
    code: 'AM',
    name: 'Armenia',
  },
  {
    code: 'AW',
    name: 'Aruba',
  },
  {
    code: 'AU',
    name: 'Australia',
  },
  {
    code: 'AT',
    name: 'Austria',
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
  },
  {
    code: 'BS',
    name: 'Bahamas',
  },
  {
    code: 'BH',
    name: 'Bahrain',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
  },
  {
    code: 'BB',
    name: 'Barbados',
  },
  {
    code: 'BY',
    name: 'Belarus',
  },
  {
    code: 'BE',
    name: 'Belgium',
  },
  {
    code: 'BZ',
    name: 'Belize',
  },
  {
    code: 'BJ',
    name: 'Benin',
  },
  {
    code: 'BM',
    name: 'Bermuda',
  },
  {
    code: 'BT',
    name: 'Bhutan',
  },
  {
    code: 'BO',
    name: 'Bolivia',
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    code: 'BW',
    name: 'Botswana',
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
  },
  {
    code: 'BR',
    name: 'Brazil',
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    code: 'VG',
    name: 'British Virgin Islands',
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
  },
  {
    code: 'BI',
    name: 'Burundi',
  },
  {
    code: 'KH',
    name: 'Cambodia',
  },
  {
    code: 'CM',
    name: 'Cameroon',
  },
  {
    code: 'CA',
    name: 'Canada',
  },
  {
    code: 'CV',
    name: 'Cape Verde',
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
  },
  {
    code: 'CF',
    name: 'Central African Republic',
  },
  {
    code: 'TD',
    name: 'Chad',
  },
  {
    code: 'CL',
    name: 'Chile',
  },
  {
    code: 'CN',
    name: 'China',
  },
  {
    code: 'CX',
    name: 'Christmas Island',
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    code: 'CO',
    name: 'Colombia',
  },
  {
    code: 'KM',
    name: 'Comoros',
  },
  {
    code: 'CD',
    name: 'Congo, Democratic Republic of the',
  },
  {
    code: 'CG',
    name: 'Congo, Republic of the',
  },
  {
    code: 'CK',
    name: 'Cook Islands',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
  },
  {
    code: 'CI',
    name: "Cote d'Ivoire",
  },
  {
    code: 'HR',
    name: 'Croatia',
  },
  {
    code: 'CU',
    name: 'Cuba',
  },
  {
    code: 'CW',
    name: 'Curacao',
  },
  {
    code: 'CY',
    name: 'Cyprus',
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
  },
  {
    code: 'DK',
    name: 'Denmark',
  },
  {
    code: 'DJ',
    name: 'Djibouti',
  },
  {
    code: 'DM',
    name: 'Dominica',
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
  },
  {
    code: 'EC',
    name: 'Ecuador',
  },
  {
    code: 'EG',
    name: 'Egypt',
  },
  {
    code: 'SV',
    name: 'El Salvador',
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    code: 'ER',
    name: 'Eritrea',
  },
  {
    code: 'EE',
    name: 'Estonia',
  },
  {
    code: 'ET',
    name: 'Ethiopia',
  },
  {
    code: 'FK',
    name: 'Falkland Islands (Malvinas)',
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
  },
  {
    code: 'FJ',
    name: 'Fiji',
  },
  {
    code: 'FI',
    name: 'Finland',
  },
  {
    code: 'FR',
    name: 'France',
  },
  {
    code: 'GF',
    name: 'French Guiana',
  },
  {
    code: 'PF',
    name: 'French Polynesia',
  },
  {
    code: 'TF',
    name: 'French Southern Territories',
  },
  {
    code: 'GA',
    name: 'Gabon',
  },
  {
    code: 'GM',
    name: 'Gambia',
  },
  {
    code: 'GE',
    name: 'Georgia',
  },
  {
    code: 'DE',
    name: 'Germany',
  },
  {
    code: 'GH',
    name: 'Ghana',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
  },
  {
    code: 'GR',
    name: 'Greece',
  },
  {
    code: 'GL',
    name: 'Greenland',
  },
  {
    code: 'GD',
    name: 'Grenada',
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
  },
  {
    code: 'GU',
    name: 'Guam',
  },
  {
    code: 'GT',
    name: 'Guatemala',
  },
  {
    code: 'GG',
    name: 'Guernsey',
  },
  {
    code: 'GN',
    name: 'Guinea',
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    code: 'GY',
    name: 'Guyana',
  },
  {
    code: 'HT',
    name: 'Haiti',
  },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    code: 'VA',
    name: 'Holy See (Vatican City State)',
  },
  {
    code: 'HN',
    name: 'Honduras',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
  },
  {
    code: 'HU',
    name: 'Hungary',
  },
  {
    code: 'IS',
    name: 'Iceland',
  },
  {
    code: 'IN',
    name: 'India',
  },
  {
    code: 'ID',
    name: 'Indonesia',
  },
  {
    code: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  {
    code: 'IQ',
    name: 'Iraq',
  },
  {
    code: 'IE',
    name: 'Ireland',
  },
  {
    code: 'IM',
    name: 'Isle of Man',
  },
  {
    code: 'IL',
    name: 'Israel',
  },
  {
    code: 'IT',
    name: 'Italy',
  },
  {
    code: 'JM',
    name: 'Jamaica',
  },
  {
    code: 'JP',
    name: 'Japan',
  },
  {
    code: 'JE',
    name: 'Jersey',
  },
  {
    code: 'JO',
    name: 'Jordan',
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
  },
  {
    code: 'KE',
    name: 'Kenya',
  },
  {
    code: 'KI',
    name: 'Kiribati',
  },
  {
    code: 'KP',
    name: "Korea, Democratic People's Republic of",
  },
  {
    code: 'KR',
    name: 'Korea, Republic of',
  },
  {
    code: 'XK',
    name: 'Kosovo',
  },
  {
    code: 'KW',
    name: 'Kuwait',
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    code: 'LA',
    name: "Lao People's Democratic Republic",
  },
  {
    code: 'LV',
    name: 'Latvia',
  },
  {
    code: 'LB',
    name: 'Lebanon',
  },
  {
    code: 'LS',
    name: 'Lesotho',
  },
  {
    code: 'LR',
    name: 'Liberia',
  },
  {
    code: 'LY',
    name: 'Libya',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
  },
  {
    code: 'LT',
    name: 'Lithuania',
  },
  {
    code: 'LU',
    name: 'Luxembourg',
  },
  {
    code: 'MO',
    name: 'Macao',
  },
  {
    code: 'MK',
    name: 'Macedonia, the Former Yugoslav Republic of',
  },
  {
    code: 'MG',
    name: 'Madagascar',
  },
  {
    code: 'MW',
    name: 'Malawi',
  },
  {
    code: 'MY',
    name: 'Malaysia',
  },
  {
    code: 'MV',
    name: 'Maldives',
  },
  {
    code: 'ML',
    name: 'Mali',
  },
  {
    code: 'MT',
    name: 'Malta',
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
  },
  {
    code: 'MQ',
    name: 'Martinique',
  },
  {
    code: 'MR',
    name: 'Mauritania',
  },
  {
    code: 'MU',
    name: 'Mauritius',
  },
  {
    code: 'YT',
    name: 'Mayotte',
  },
  {
    code: 'MX',
    name: 'Mexico',
  },
  {
    code: 'FM',
    name: 'Micronesia, Federated States of',
  },
  {
    code: 'MD',
    name: 'Moldova, Republic of',
  },
  {
    code: 'MC',
    name: 'Monaco',
  },
  {
    code: 'MN',
    name: 'Mongolia',
  },
  {
    code: 'ME',
    name: 'Montenegro',
  },
  {
    code: 'MS',
    name: 'Montserrat',
  },
  {
    code: 'MA',
    name: 'Morocco',
  },
  {
    code: 'MZ',
    name: 'Mozambique',
  },
  {
    code: 'MM',
    name: 'Myanmar',
  },
  {
    code: 'NA',
    name: 'Namibia',
  },
  {
    code: 'NR',
    name: 'Nauru',
  },
  {
    code: 'NP',
    name: 'Nepal',
  },
  {
    code: 'NL',
    name: 'Netherlands',
  },
  {
    code: 'NC',
    name: 'New Caledonia',
  },
  {
    code: 'NZ',
    name: 'New Zealand',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
  },
  {
    code: 'NE',
    name: 'Niger',
  },
  {
    code: 'NG',
    name: 'Nigeria',
  },
  {
    code: 'NU',
    name: 'Niue',
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    code: 'NO',
    name: 'Norway',
  },
  {
    code: 'OM',
    name: 'Oman',
  },
  {
    code: 'PK',
    name: 'Pakistan',
  },
  {
    code: 'PW',
    name: 'Palau',
  },
  {
    code: 'PS',
    name: 'Palestine, State of',
  },
  {
    code: 'PA',
    name: 'Panama',
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
  },
  {
    code: 'PY',
    name: 'Paraguay',
  },
  {
    code: 'PE',
    name: 'Peru',
  },
  {
    code: 'PH',
    name: 'Philippines',
  },
  {
    code: 'PN',
    name: 'Pitcairn',
  },
  {
    code: 'PL',
    name: 'Poland',
  },
  {
    code: 'PT',
    name: 'Portugal',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
  },
  {
    code: 'QA',
    name: 'Qatar',
  },
  {
    code: 'RE',
    name: 'Reunion',
  },
  {
    code: 'RO',
    name: 'Romania',
  },
  {
    code: 'RU',
    name: 'Russian Federation',
  },
  {
    code: 'RW',
    name: 'Rwanda',
  },
  {
    code: 'BL',
    name: 'Saint Barthelemy',
  },
  {
    code: 'SH',
    name: 'Saint Helena',
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
  },
  {
    code: 'MF',
    name: 'Saint Martin (French part)',
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'WS',
    name: 'Samoa',
  },
  {
    code: 'SM',
    name: 'San Marino',
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
  },
  {
    code: 'SN',
    name: 'Senegal',
  },
  {
    code: 'RS',
    name: 'Serbia',
  },
  {
    code: 'SC',
    name: 'Seychelles',
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
  },
  {
    code: 'SG',
    name: 'Singapore',
  },
  {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
  },
  {
    code: 'SK',
    name: 'Slovakia',
  },
  {
    code: 'SI',
    name: 'Slovenia',
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
  },
  {
    code: 'SO',
    name: 'Somalia',
  },
  {
    code: 'ZA',
    name: 'South Africa',
  },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
  },
  {
    code: 'SS',
    name: 'South Sudan',
  },
  {
    code: 'ES',
    name: 'Spain',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
  },
  {
    code: 'SD',
    name: 'Sudan',
  },
  {
    code: 'SR',
    name: 'Suriname',
  },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  {
    code: 'SZ',
    name: 'Swaziland',
  },
  {
    code: 'SE',
    name: 'Sweden',
  },
  {
    code: 'CH',
    name: 'Switzerland',
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    code: 'TW',
    name: 'Taiwan, Republic of China',
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
  },
  {
    code: 'TH',
    name: 'Thailand',
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
  },
  {
    code: 'TG',
    name: 'Togo',
  },
  {
    code: 'TK',
    name: 'Tokelau',
  },
  {
    code: 'TO',
    name: 'Tonga',
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    code: 'TN',
    name: 'Tunisia',
  },
  {
    code: 'TR',
    name: 'Turkey',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
  },
  {
    code: 'VI',
    name: 'US Virgin Islands',
  },
  {
    code: 'UG',
    name: 'Uganda',
  },
  {
    code: 'UA',
    name: 'Ukraine',
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
  },
  {
    code: 'TZ',
    name: 'United Republic of Tanzania',
  },
  {
    code: 'US',
    name: 'United States',
  },
  {
    code: 'UY',
    name: 'Uruguay',
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
  },
  {
    code: 'VE',
    name: 'Venezuela',
  },
  {
    code: 'VN',
    name: 'Vietnam',
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    code: 'EH',
    name: 'Western Sahara',
  },
  {
    code: 'YE',
    name: 'Yemen',
  },
  {
    code: 'ZM',
    name: 'Zambia',
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
  },
];

const countriesInGerman: ITranslatedCountry[] = [
  {
    code: 'AF',
    name: 'Afghanistan',
  },
  {
    code: 'AL',
    name: 'Albanien',
  },
  {
    code: 'DZ',
    name: 'Algerien',
  },
  {
    code: 'AX',
    name: 'Ålandinseln',
  },
  {
    code: 'AS',
    name: 'Amerikanisch-Samoa',
  },
  {
    code: 'AD',
    name: 'Andorra',
  },
  {
    code: 'AO',
    name: 'Angola',
  },
  {
    code: 'AI',
    name: 'Anguilla',
  },
  {
    code: 'AQ',
    name: 'Antarktis',
  },
  {
    code: 'AG',
    name: 'Antigua und Barbuda',
  },
  {
    code: 'AR',
    name: 'Argentinien',
  },
  {
    code: 'AM',
    name: 'Armenien',
  },
  {
    code: 'AW',
    name: 'Aruba',
  },
  {
    code: 'AU',
    name: 'Australien',
  },
  {
    code: 'AT',
    name: 'Österreich',
  },
  {
    code: 'AZ',
    name: 'Aserbaidschan',
  },
  {
    code: 'BS',
    name: 'Bahamas',
  },
  {
    code: 'BH',
    name: 'Bahrain',
  },
  {
    code: 'BD',
    name: 'Bangladesch',
  },
  {
    code: 'BB',
    name: 'Barbados',
  },
  {
    code: 'BY',
    name: 'Weißrussland',
  },
  {
    code: 'BE',
    name: 'Belgien',
  },
  {
    code: 'BZ',
    name: 'Belize',
  },
  {
    code: 'BJ',
    name: 'Benin',
  },
  {
    code: 'BM',
    name: 'Bermuda',
  },
  {
    code: 'BT',
    name: 'Bhutan',
  },
  {
    code: 'BO',
    name: 'Bolivien',
  },
  {
    code: 'BA',
    name: 'Bosnien und Herzegowina',
  },
  {
    code: 'BW',
    name: 'Botswana',
  },
  {
    code: 'BV',
    name: 'Bouvetinsel',
  },
  {
    code: 'BR',
    name: 'Brasilien',
  },
  {
    code: 'IO',
    name: 'Britisches Territorium im Indischen Ozean',
  },
  {
    code: 'VG',
    name: 'Britische Jungferninseln',
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    code: 'BG',
    name: 'Bulgarien',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
  },
  {
    code: 'BI',
    name: 'Burundi',
  },
  {
    code: 'KH',
    name: 'Kambodscha',
  },
  {
    code: 'CM',
    name: 'Kamerun',
  },
  {
    code: 'CA',
    name: 'Kanada',
  },
  {
    code: 'CV',
    name: 'Kap Verde',
  },
  {
    code: 'KY',
    name: 'Kaimaninseln',
  },
  {
    code: 'CF',
    name: 'Zentralafrikanische Republik',
  },
  {
    code: 'TD',
    name: 'Tschad',
  },
  {
    code: 'CL',
    name: 'Chile',
  },
  {
    code: 'CN',
    name: 'China',
  },
  {
    code: 'CX',
    name: 'Weihnachtsinsel',
  },
  {
    code: 'CC',
    name: 'Kokosinseln (Keelinginseln)',
  },
  {
    code: 'CO',
    name: 'Kolumbien',
  },
  {
    code: 'KM',
    name: 'Komoren',
  },
  {
    code: 'CD',
    name: 'Kongo, Demokratische Republik des',
  },
  {
    code: 'CG',
    name: 'Kongo, Republik des',
  },
  {
    code: 'CK',
    name: 'Cookinseln',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
  },
  {
    code: 'CI',
    name: 'Elfenbeinküste',
  },
  {
    code: 'HR',
    name: 'Kroatien',
  },
  {
    code: 'CU',
    name: 'Kuba',
  },
  {
    code: 'CW',
    name: 'Curaçao',
  },
  {
    code: 'CY',
    name: 'Zypern',
  },
  {
    code: 'CZ',
    name: 'Tschechien',
  },
  {
    code: 'DK',
    name: 'Dänemark',
  },
  {
    code: 'DJ',
    name: 'Dschibuti',
  },
  {
    code: 'DM',
    name: 'Dominica',
  },
  {
    code: 'DO',
    name: 'Dominikanische Republik',
  },
  {
    code: 'EC',
    name: 'Ecuador',
  },
  {
    code: 'EG',
    name: 'Ägypten',
  },
  {
    code: 'SV',
    name: 'El Salvador',
  },
  {
    code: 'GQ',
    name: 'Äquatorialguinea',
  },
  {
    code: 'ER',
    name: 'Eritrea',
  },
  {
    code: 'EE',
    name: 'Estland',
  },
  {
    code: 'ET',
    name: 'Äthiopien',
  },
  {
    code: 'FK',
    name: 'Falklandinseln (Malwinen)',
  },
  {
    code: 'FO',
    name: 'Färöer-Inseln',
  },
  {
    code: 'FJ',
    name: 'Fidschi',
  },
  {
    code: 'FI',
    name: 'Finnland',
  },
  {
    code: 'FR',
    name: 'Frankreich',
  },
  {
    code: 'GF',
    name: 'Französisch-Guayana',
  },
  {
    code: 'PF',
    name: 'Französisch-Polynesien',
  },
  {
    code: 'TF',
    name: 'Französische Süd- und Antarktisgebiete',
  },
  {
    code: 'GA',
    name: 'Gabun',
  },
  {
    code: 'GM',
    name: 'Gambia',
  },
  {
    code: 'GE',
    name: 'Georgien',
  },
  {
    code: 'DE',
    name: 'Deutschland',
  },
  {
    code: 'GH',
    name: 'Ghana',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
  },
  {
    code: 'GR',
    name: 'Griechenland',
  },
  {
    code: 'GL',
    name: 'Grönland',
  },
  {
    code: 'GD',
    name: 'Grenada',
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
  },
  {
    code: 'GU',
    name: 'Guam',
  },
  {
    code: 'GT',
    name: 'Guatemala',
  },
  {
    code: 'GG',
    name: 'Guernsey',
  },
  {
    code: 'GN',
    name: 'Guinea',
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    code: 'GY',
    name: 'Guyana',
  },
  {
    code: 'HT',
    name: 'Haiti',
  },
  {
    code: 'HM',
    name: 'Heard- und McDonald-Inseln',
  },
  {
    code: 'VA',
    name: 'Heiliger Stuhl (Vatikansstaat)',
  },
  {
    code: 'HN',
    name: 'Honduras',
  },
  {
    code: 'HK',
    name: 'Hongkong',
  },
  {
    code: 'HU',
    name: 'Ungarn',
  },
  {
    code: 'IS',
    name: 'Island',
  },
  {
    code: 'IN',
    name: 'Indien',
  },
  {
    code: 'ID',
    name: 'Indonesien',
  },
  {
    code: 'IR',
    name: 'Iran',
  },
  {
    code: 'IQ',
    name: 'Irak',
  },
  {
    code: 'IE',
    name: 'Irland',
  },
  {
    code: 'IL',
    name: 'Israel',
  },
  {
    code: 'IT',
    name: 'Italien',
  },
  {
    code: 'JM',
    name: 'Jamaika',
  },
  {
    code: 'JP',
    name: 'Japan',
  },
  {
    code: 'JE',
    name: 'Jersey',
  },
  {
    code: 'JO',
    name: 'Jordanien',
  },
  {
    code: 'KZ',
    name: 'Kasachstan',
  },
  {
    code: 'KE',
    name: 'Kenia',
  },
  {
    code: 'KI',
    name: 'Kiribati',
  },
  {
    code: 'KW',
    name: 'Kuwait',
  },
  {
    code: 'KG',
    name: 'Kirgisistan',
  },
  {
    code: 'LA',
    name: 'Laos',
  },
  {
    code: 'LV',
    name: 'Lettland',
  },
  {
    code: 'LB',
    name: 'Libanon',
  },
  {
    code: 'LS',
    name: 'Lesotho',
  },
  {
    code: 'LR',
    name: 'Liberia',
  },
  {
    code: 'LY',
    name: 'Libyen',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
  },
  {
    code: 'LT',
    name: 'Litauen',
  },
  {
    code: 'LU',
    name: 'Luxemburg',
  },
  {
    code: 'MO',
    name: 'Macao',
  },
  {
    code: 'MK',
    name: 'Nordmazedonien',
  },
  {
    code: 'MG',
    name: 'Madagaskar',
  },
  {
    code: 'MW',
    name: 'Malawi',
  },
  {
    code: 'MY',
    name: 'Malaysia',
  },
  {
    code: 'MV',
    name: 'Malediven',
  },
  {
    code: 'ML',
    name: 'Mali',
  },
  {
    code: 'MT',
    name: 'Malta',
  },
  {
    code: 'MH',
    name: 'Marshallinseln',
  },
  {
    code: 'MQ',
    name: 'Martinique',
  },
  {
    code: 'MR',
    name: 'Mauretanien',
  },
  {
    code: 'MU',
    name: 'Mauritius',
  },
  {
    code: 'YT',
    name: 'Mayotte',
  },
  {
    code: 'MX',
    name: 'Mexiko',
  },
  {
    code: 'FM',
    name: 'Mikronesien',
  },
  {
    code: 'MD',
    name: 'Moldawien',
  },
  {
    code: 'MC',
    name: 'Monaco',
  },
  {
    code: 'MN',
    name: 'Mongolei',
  },
  {
    code: 'ME',
    name: 'Montenegro',
  },
  {
    code: 'MS',
    name: 'Montserrat',
  },
  {
    code: 'MA',
    name: 'Marokko',
  },
  {
    code: 'MZ',
    name: 'Mosambik',
  },
  {
    code: 'MM',
    name: 'Myanmar',
  },
  {
    code: 'NA',
    name: 'Namibia',
  },
  {
    code: 'NR',
    name: 'Nauru',
  },
  {
    code: 'NP',
    name: 'Nepal',
  },
  {
    code: 'NL',
    name: 'Niederlande',
  },
  {
    code: 'NC',
    name: 'Neukaledonien',
  },
  {
    code: 'NZ',
    name: 'Neuseeland',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
  },
  {
    code: 'NE',
    name: 'Niger',
  },
  {
    code: 'NG',
    name: 'Nigeria',
  },
  {
    code: 'NU',
    name: 'Niue',
  },
  {
    code: 'NF',
    name: 'Norfolkinsel',
  },
  {
    code: 'MP',
    name: 'Nordmarianen',
  },
  {
    code: 'NO',
    name: 'Norwegen',
  },
  {
    code: 'OM',
    name: 'Oman',
  },
  {
    code: 'PK',
    name: 'Pakistan',
  },
  {
    code: 'PW',
    name: 'Palau',
  },
  {
    code: 'PS',
    name: 'Palästinensische Gebiete',
  },
  {
    code: 'PA',
    name: 'Panama',
  },
  {
    code: 'PG',
    name: 'Papua-Neuguinea',
  },
  {
    code: 'PY',
    name: 'Paraguay',
  },
  {
    code: 'PE',
    name: 'Peru',
  },
  {
    code: 'PH',
    name: 'Philippinen',
  },
  {
    code: 'PN',
    name: 'Pitcairninseln',
  },
  {
    code: 'PL',
    name: 'Polen',
  },
  {
    code: 'PT',
    name: 'Portugal',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
  },
  {
    code: 'QA',
    name: 'Katar',
  },
  {
    code: 'RE',
    name: 'Réunion',
  },
  {
    code: 'RO',
    name: 'Rumänien',
  },
  {
    code: 'RU',
    name: 'Russland',
  },
  {
    code: 'RW',
    name: 'Ruanda',
  },
  {
    code: 'BL',
    name: 'Saint-Barthélemy',
  },
  {
    code: 'SH',
    name: 'Saint Helena',
  },
  {
    code: 'KN',
    name: 'Saint Kitts und Nevis',
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
  },
  {
    code: 'MF',
    name: 'Saint-Martin (französisch)',
  },
  {
    code: 'PM',
    name: 'Saint-Pierre und Miquelon',
  },
  {
    code: 'VC',
    name: 'Saint Vincent und die Grenadinen',
  },
  {
    code: 'WS',
    name: 'Samoa',
  },
  {
    code: 'SM',
    name: 'San Marino',
  },
  {
    code: 'ST',
    name: 'São Tomé und Príncipe',
  },
  {
    code: 'SA',
    name: 'Saudi-Arabien',
  },
  {
    code: 'SN',
    name: 'Senegal',
  },
  {
    code: 'RS',
    name: 'Serbien',
  },
  {
    code: 'SC',
    name: 'Seychellen',
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
  },
  {
    code: 'SG',
    name: 'Singapur',
  },
  {
    code: 'SX',
    name: 'Sint Maarten (niederländischer Teil)',
  },
  {
    code: 'SK',
    name: 'Slowakei',
  },
  {
    code: 'SI',
    name: 'Slowenien',
  },
  {
    code: 'SB',
    name: 'Salomonen',
  },
  {
    code: 'SO',
    name: 'Somalia',
  },
  {
    code: 'ZA',
    name: 'Südafrika',
  },
  {
    code: 'GS',
    name: 'Südgeorgien und die Südlichen Sandwichinseln',
  },
  {
    code: 'KR',
    name: 'Südkorea',
  },
  {
    code: 'SS',
    name: 'Südsudan',
  },
  {
    code: 'ES',
    name: 'Spanien',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
  },
  {
    code: 'SD',
    name: 'Sudan',
  },
  {
    code: 'SR',
    name: 'Surinam',
  },
  {
    code: 'SJ',
    name: 'Svalbard und Jan Mayen',
  },
  {
    code: 'SZ',
    name: 'Swasiland',
  },
  {
    code: 'SE',
    name: 'Schweden',
  },
  {
    code: 'CH',
    name: 'Schweiz',
  },
  {
    code: 'SY',
    name: 'Syrien',
  },
  {
    code: 'TW',
    name: 'Taiwan',
  },
  {
    code: 'TJ',
    name: 'Tadschikistan',
  },
  {
    code: 'TZ',
    name: 'Tansania',
  },
  {
    code: 'TH',
    name: 'Thailand',
  },
  {
    code: 'TL',
    name: 'Osttimor',
  },
  {
    code: 'TG',
    name: 'Togo',
  },
  {
    code: 'TK',
    name: 'Tokelau',
  },
  {
    code: 'TO',
    name: 'Tonga',
  },
  {
    code: 'TT',
    name: 'Trinidad und Tobago',
  },
  {
    code: 'TN',
    name: 'Tunesien',
  },
  {
    code: 'TR',
    name: 'Türkei',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
  },
  {
    code: 'TC',
    name: 'Turks- und Caicosinseln',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
  },
  {
    code: 'UG',
    name: 'Uganda',
  },
  {
    code: 'UA',
    name: 'Ukraine',
  },
  {
    code: 'AE',
    name: 'Vereinigte Arabische Emirate',
  },
  {
    code: 'GB',
    name: 'Vereinigtes Königreich',
  },
  {
    code: 'US',
    name: 'Vereinigte Staaten',
  },
  {
    code: 'UY',
    name: 'Uruguay',
  },
  {
    code: 'UZ',
    name: 'Usbekistan',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
  },
  {
    code: 'VA',
    name: 'Vatikansstaat',
  },
  {
    code: 'VE',
    name: 'Venezuela',
  },
  {
    code: 'VN',
    name: 'Vietnam',
  },
  {
    code: 'WF',
    name: 'Wallis und Futuna',
  },
  {
    code: 'EH',
    name: 'Westsahara',
  },
  {
    code: 'YE',
    name: 'Jemen',
  },
  {
    code: 'ZM',
    name: 'Sambia',
  },
  {
    code: 'ZW',
    name: 'Simbabwe',
  },
];

const countriesInSpanish: ITranslatedCountry[] = [
  {
    code: 'AF',
    name: 'Afganistán',
  },
  {
    code: 'AL',
    name: 'Albania',
  },
  {
    code: 'DZ',
    name: 'Argelia',
  },
  {
    code: 'AS',
    name: 'Samoa Americana',
  },
  {
    code: 'AD',
    name: 'Andorra',
  },
  {
    code: 'AO',
    name: 'Angola',
  },
  {
    code: 'AI',
    name: 'Anguila',
  },
  {
    code: 'AQ',
    name: 'Antártida',
  },
  {
    code: 'AG',
    name: 'Antigua y Barbuda',
  },
  {
    code: 'AR',
    name: 'Argentina',
  },
  {
    code: 'AM',
    name: 'Armenia',
  },
  {
    code: 'AW',
    name: 'Aruba',
  },
  {
    code: 'AU',
    name: 'Australia',
  },
  {
    code: 'AT',
    name: 'Austria',
  },
  {
    code: 'AZ',
    name: 'Azerbaiyán',
  },
  {
    code: 'BS',
    name: 'Bahamas',
  },
  {
    code: 'BH',
    name: 'Baréin',
  },
  {
    code: 'BD',
    name: 'Bangladés',
  },
  {
    code: 'BB',
    name: 'Barbados',
  },
  {
    code: 'BY',
    name: 'Bielorrusia',
  },
  {
    code: 'BE',
    name: 'Bélgica',
  },
  {
    code: 'BZ',
    name: 'Belice',
  },
  {
    code: 'BJ',
    name: 'Benín',
  },
  {
    code: 'BM',
    name: 'Bermudas',
  },
  {
    code: 'BT',
    name: 'Bután',
  },
  {
    code: 'BO',
    name: 'Bolivia',
  },
  {
    code: 'BA',
    name: 'Bosnia y Herzegovina',
  },
  {
    code: 'BW',
    name: 'Botsuana',
  },
  {
    code: 'BR',
    name: 'Brasil',
  },
  {
    code: 'IO',
    name: 'Territorio Británico del Océano Índico',
  },
  {
    code: 'BN',
    name: 'Brunéi',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
  },
  {
    code: 'BI',
    name: 'Burundi',
  },
  {
    code: 'KH',
    name: 'Camboya',
  },
  {
    code: 'CM',
    name: 'Camerún',
  },
  {
    code: 'CA',
    name: 'Canadá',
  },
  {
    code: 'CV',
    name: 'Cabo Verde',
  },
  {
    code: 'KY',
    name: 'Islas Caimán',
  },
  {
    code: 'CF',
    name: 'República Centroafricana',
  },
  {
    code: 'TD',
    name: 'Chad',
  },
  {
    code: 'CL',
    name: 'Chile',
  },
  {
    code: 'CN',
    name: 'China',
  },
  {
    code: 'CX',
    name: 'Isla Christmas',
  },
  {
    code: 'CC',
    name: 'Islas Cocos',
  },
  {
    code: 'CO',
    name: 'Colombia',
  },
  {
    code: 'KM',
    name: 'Comoras',
  },
  {
    code: 'CG',
    name: 'República del Congo',
  },
  {
    code: 'CD',
    name: 'República Democrática del Congo',
  },
  {
    code: 'CK',
    name: 'Islas Cook',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
  },
  {
    code: 'HR',
    name: 'Croacia',
  },
  {
    code: 'CU',
    name: 'Cuba',
  },
  {
    code: 'CY',
    name: 'Chipre',
  },
  {
    code: 'CZ',
    name: 'República Checa',
  },
  {
    code: 'DK',
    name: 'Dinamarca',
  },
  {
    code: 'DJ',
    name: 'Yibuti',
  },
  {
    code: 'DM',
    name: 'Dominica',
  },
  {
    code: 'DO',
    name: 'República Dominicana',
  },
  {
    code: 'EC',
    name: 'Ecuador',
  },
  {
    code: 'EG',
    name: 'Egipto',
  },
  {
    code: 'SV',
    name: 'El Salvador',
  },
  {
    code: 'GQ',
    name: 'Guinea Ecuatorial',
  },
  {
    code: 'ER',
    name: 'Eritrea',
  },
  {
    code: 'EE',
    name: 'Estonia',
  },
  {
    code: 'SZ',
    name: 'Esuatini',
  },
  {
    code: 'ET',
    name: 'Etiopía',
  },
  {
    code: 'FK',
    name: 'Islas Malvinas',
  },
  {
    code: 'FO',
    name: 'Islas Feroe',
  },
  {
    code: 'FJ',
    name: 'Fiyi',
  },
  {
    code: 'FI',
    name: 'Finlandia',
  },
  {
    code: 'FR',
    name: 'Francia',
  },
  {
    code: 'GF',
    name: 'Guayana Francesa',
  },
  {
    code: 'PF',
    name: 'Polinesia Francesa',
  },
  {
    code: 'GA',
    name: 'Gabón',
  },
  {
    code: 'GM',
    name: 'Gambia',
  },
  {
    code: 'GE',
    name: 'Georgia',
  },
  {
    code: 'DE',
    name: 'Alemania',
  },
  {
    code: 'GH',
    name: 'Ghana',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
  },
  {
    code: 'GR',
    name: 'Grecia',
  },
  {
    code: 'GL',
    name: 'Groenlandia',
  },
  {
    code: 'GD',
    name: 'Granada',
  },
  {
    code: 'GP',
    name: 'Guadalupe',
  },
  {
    code: 'GU',
    name: 'Guam',
  },
  {
    code: 'GT',
    name: 'Guatemala',
  },
  {
    code: 'GN',
    name: 'Guinea',
  },
  {
    code: 'GW',
    name: 'Guinea-Bisáu',
  },
  {
    code: 'GY',
    name: 'Guyana',
  },
  {
    code: 'HT',
    name: 'Haití',
  },
  {
    code: 'HM',
    name: 'Islas Heard y McDonald',
  },
  {
    code: 'HN',
    name: 'Honduras',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
  },
  {
    code: 'HU',
    name: 'Hungría',
  },
  {
    code: 'IS',
    name: 'Islandia',
  },
  {
    code: 'IN',
    name: 'India',
  },
  {
    code: 'ID',
    name: 'Indonesia',
  },
  {
    code: 'IR',
    name: 'Irán',
  },
  {
    code: 'IQ',
    name: 'Irak',
  },
  {
    code: 'IE',
    name: 'Irlanda',
  },
  {
    code: 'IL',
    name: 'Israel',
  },
  {
    code: 'IT',
    name: 'Italia',
  },
  {
    code: 'JM',
    name: 'Jamaica',
  },
  {
    code: 'JP',
    name: 'Japón',
  },
  {
    code: 'JO',
    name: 'Jordania',
  },
  {
    code: 'KZ',
    name: 'Kazajistán',
  },
  {
    code: 'KE',
    name: 'Kenia',
  },
  {
    code: 'KI',
    name: 'Kiribati',
  },
  {
    code: 'KW',
    name: 'Kuwait',
  },
  {
    code: 'KG',
    name: 'Kirguistán',
  },
  {
    code: 'LA',
    name: 'Laos',
  },
  {
    code: 'LV',
    name: 'Letonia',
  },
  {
    code: 'LB',
    name: 'Líbano',
  },
  {
    code: 'LS',
    name: 'Lesoto',
  },
  {
    code: 'LR',
    name: 'Liberia',
  },
  {
    code: 'LY',
    name: 'Libia',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
  },
  {
    code: 'LT',
    name: 'Lituania',
  },
  {
    code: 'LU',
    name: 'Luxemburgo',
  },
  {
    code: 'MO',
    name: 'Macao',
  },
  {
    code: 'MK',
    name: 'Macedonia del Norte',
  },
  {
    code: 'MG',
    name: 'Madagascar',
  },
  {
    code: 'MW',
    name: 'Malawi',
  },
  {
    code: 'MY',
    name: 'Malasia',
  },
  {
    code: 'MV',
    name: 'Maldivas',
  },
  {
    code: 'ML',
    name: 'Malí',
  },
  {
    code: 'MT',
    name: 'Malta',
  },
  {
    code: 'MH',
    name: 'Islas Marshall',
  },
  {
    code: 'MQ',
    name: 'Martinica',
  },
  {
    code: 'MR',
    name: 'Mauritania',
  },
  {
    code: 'MU',
    name: 'Mauricio',
  },
  {
    code: 'YT',
    name: 'Mayotte',
  },
  {
    code: 'MX',
    name: 'México',
  },
  {
    code: 'FM',
    name: 'Micronesia',
  },
  {
    code: 'MD',
    name: 'Moldavia',
  },
  {
    code: 'MC',
    name: 'Mónaco',
  },
  {
    code: 'MN',
    name: 'Mongolia',
  },
  {
    code: 'ME',
    name: 'Montenegro',
  },
  {
    code: 'MS',
    name: 'Montserrat',
  },
  {
    code: 'MA',
    name: 'Marruecos',
  },
  {
    code: 'MZ',
    name: 'Mozambique',
  },
  {
    code: 'MM',
    name: 'Birmania',
  },
  {
    code: 'NA',
    name: 'Namibia',
  },
  {
    code: 'NR',
    name: 'Nauru',
  },
  {
    code: 'NP',
    name: 'Nepal',
  },
  {
    code: 'NL',
    name: 'Países Bajos',
  },
  {
    code: 'NC',
    name: 'Nueva Caledonia',
  },
  {
    code: 'NZ',
    name: 'Nueva Zelanda',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
  },
  {
    code: 'NE',
    name: 'Níger',
  },
  {
    code: 'NG',
    name: 'Nigeria',
  },
  {
    code: 'NU',
    name: 'Niue',
  },
  {
    code: 'NF',
    name: 'Isla Norfolk',
  },
  {
    code: 'MP',
    name: 'Islas Marianas del Norte',
  },
  {
    code: 'NO',
    name: 'Noruega',
  },
  {
    code: 'OM',
    name: 'Omán',
  },
  {
    code: 'PK',
    name: 'Pakistán',
  },
  {
    code: 'PW',
    name: 'Palaos',
  },
  {
    code: 'PS',
    name: 'Palestina',
  },
  {
    code: 'PA',
    name: 'Panamá',
  },
  {
    code: 'PG',
    name: 'Papúa Nueva Guinea',
  },
  {
    code: 'PY',
    name: 'Paraguay',
  },
  {
    code: 'PE',
    name: 'Perú',
  },
  {
    code: 'PH',
    name: 'Filipinas',
  },
  {
    code: 'PN',
    name: 'Islas Pitcairn',
  },
  {
    code: 'PL',
    name: 'Polonia',
  },
  {
    code: 'PT',
    name: 'Portugal',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
  },
  {
    code: 'QA',
    name: 'Catar',
  },
  {
    code: 'RE',
    name: 'Reunión',
  },
  {
    code: 'RO',
    name: 'Rumanía',
  },
  {
    code: 'RU',
    name: 'Rusia',
  },
  {
    code: 'RW',
    name: 'Ruanda',
  },
  {
    code: 'BL',
    name: 'San Bartolomé',
  },
  {
    code: 'SH',
    name: 'Santa Elena',
  },
  {
    code: 'KN',
    name: 'San Cristóbal y Nieves',
  },
  {
    code: 'LC',
    name: 'Santa Lucía',
  },
  {
    code: 'MF',
    name: 'San Martín',
  },
  {
    code: 'PM',
    name: 'San Pedro y Miquelón',
  },
  {
    code: 'VC',
    name: 'San Vicente y las Granadinas',
  },
  {
    code: 'WS',
    name: 'Samoa',
  },
  {
    code: 'SM',
    name: 'San Marino',
  },
  {
    code: 'ST',
    name: 'Santo Tomé y Príncipe',
  },
  {
    code: 'SA',
    name: 'Arabia Saudita',
  },
  {
    code: 'SN',
    name: 'Senegal',
  },
  {
    code: 'RS',
    name: 'Serbia',
  },
  {
    code: 'SC',
    name: 'Seychelles',
  },
  {
    code: 'SL',
    name: 'Sierra Leona',
  },
  {
    code: 'SG',
    name: 'Singapur',
  },
  {
    code: 'SK',
    name: 'Eslovaquia',
  },
  {
    code: 'SI',
    name: 'Eslovenia',
  },
  {
    code: 'SB',
    name: 'Islas Salomón',
  },
  {
    code: 'SO',
    name: 'Somalia',
  },
  {
    code: 'ZA',
    name: 'Sudáfrica',
  },
  {
    code: 'GS',
    name: 'Georgia del Sur y las Islas Sandwich del Sur',
  },
  {
    code: 'KR',
    name: 'Corea del Sur',
  },
  {
    code: 'SS',
    name: 'Sudán del Sur',
  },
  {
    code: 'ES',
    name: 'España',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
  },
  {
    code: 'SD',
    name: 'Sudán',
  },
  {
    code: 'SR',
    name: 'Surinam',
  },
  {
    code: 'SJ',
    name: 'Svalbard y Jan Mayen',
  },
  {
    code: 'SZ',
    name: 'Suazilandia',
  },
  {
    code: 'SE',
    name: 'Suecia',
  },
  {
    code: 'CH',
    name: 'Suiza',
  },
  {
    code: 'SY',
    name: 'Siria',
  },
  {
    code: 'TW',
    name: 'Taiwán',
  },
  {
    code: 'TJ',
    name: 'Tayikistán',
  },
  {
    code: 'TZ',
    name: 'Tanzania',
  },
  {
    code: 'TH',
    name: 'Tailandia',
  },
  {
    code: 'TL',
    name: 'Timor Oriental',
  },
  {
    code: 'TG',
    name: 'Togo',
  },
  {
    code: 'TK',
    name: 'Tokelau',
  },
  {
    code: 'TO',
    name: 'Tonga',
  },
  {
    code: 'TT',
    name: 'Trinidad y Tobago',
  },
  {
    code: 'TN',
    name: 'Túnez',
  },
  {
    code: 'TR',
    name: 'Turquía',
  },
  {
    code: 'TM',
    name: 'Turkmenistán',
  },
  {
    code: 'TC',
    name: 'Islas Turcas y Caicos',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
  },
  {
    code: 'UG',
    name: 'Uganda',
  },
  {
    code: 'UA',
    name: 'Ucrania',
  },
  {
    code: 'AE',
    name: 'Emiratos Árabes Unidos',
  },
  {
    code: 'GB',
    name: 'Reino Unido',
  },
  {
    code: 'US',
    name: 'Estados Unidos',
  },
  {
    code: 'UY',
    name: 'Uruguay',
  },
  {
    code: 'UZ',
    name: 'Uzbekistán',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
  },
  {
    code: 'VE',
    name: 'Venezuela',
  },
  {
    code: 'VN',
    name: 'Vietnam',
  },
  {
    code: 'WF',
    name: 'Wallis y Futuna',
  },
  {
    code: 'EH',
    name: 'Sáhara Occidental',
  },
  {
    code: 'YE',
    name: 'Yemen',
  },
  {
    code: 'ZM',
    name: 'Zambia',
  },
  {
    code: 'ZW',
    name: 'Zimbabue',
  },
];

const countriesByLanguage: CountriesDictionary = {
  de: countriesInGerman,
  en: countriesInEnglish,
  es: countriesInSpanish,
};

const translateCountries = (language: string, countries: ICountry[]) => {
  let translatedCountries: ITranslatedCountry[];

  if (countriesByLanguage[language] && language !== 'en') {
    translatedCountries = countriesByLanguage[language];
  } else {
    return countries;
  }

  countries.forEach((country: ICountry) => {
    const translatedCountry = translatedCountries.find(tc => tc.code === country.code);
    if (translatedCountry){
      country.name = translatedCountry.name;
    }
  });

  return countries;
};
